import React from 'react';
import API from '../../servicios/api';

class Intro extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            // datosCargados:false,
            terminos:false,
            empleado: [],
            errores: [],
            serverror:""
        }
    }

    aceptarTerminos = (e) => {
        // console.log(e.target.value);
        this.setState( { terminos:!this.state.terminos});
    }
    enviarDatos = (e) => {
        e.preventDefault();
        let {  docId  } = this.state;
        // Validar Errores
        let errores = [];
        if (!docId) errores.push('error_docId');
        this.setState({errores:errores});
        if (errores.length>0) {
            console.log(errores);
            return false;
        }
        // querybyDocId -> consulta en la tabla Beneficiarios
        // fetch(API +"?consultarbyDocId", { // Consulta en la tabla grb_empleados
        fetch(API +"?querybyDocId=", {
            method:"POST",
            body: JSON.stringify({docId:docId})
        })
        .then(respuesta => respuesta.json())
        .then((datos)=>{
            console.log(datos);
            if (datos.error && datos.error!==""){
                // console.error(datos.error);
                this.setState({serverror:datos.error});
            } else {
                if (datos.length>0 && datos[0].claveAPI!==""){
                    // this.props.history.push("/perfileditar/"+datos[0].id);
                    if (datos[0].claveAPI!==null && datos[0].claveAPI!==undefined){
                        // Cambiar a key del API para evitar usuarios curiosos
                        this.props.history.push("/perfileditar/"+datos[0].claveAPI);
                    } else {
                        // Usuario existe pero no tiene definida una claveAPI en la tabla beneficiarios
                        this.props.history.push("/perfil/"+docId);
                    }
                    
                } else { //if(datos.info){ //"Usuario no existe"
                    this.props.history.push("/perfil/"+docId);
                }
                
            }
        })
        .catch(console.log)
    }

    verificarError(elm){
        return this.state.errores.indexOf(elm) !== -1;
    }

    cambioValor = (e) =>{
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState( { state, errores:[], serverror:""});
    }

    render() { 
        const { 
            terminos, empleado, serverror
        } = this.state;
        return (  
            <div className="card">
                <div className="card-header">
                    <div className='encuesta-title'>
                        <div><strong>ENCUESTA</strong></div>
                        <div className='fecha-encuesta'>{new Date().toLocaleString()}</div>
                    </div>
                </div>
                <div className="card-body">
                    {/* <div className='encuesta-ecase-title'>ENCUESTA CARACTERIZACIÓN SOCIAL Y ECONÓMICA</div> */}
                    <div className='encuesta-ecase-desc'>
                        <p>Proyecto para la <strong>Caracterización Social y Económica</strong> de empleados beneficiarios.</p>
                        <p>A continuación encontrará una serie de preguntas que tienen como objetivo construir el perfil socioeconómico y conocer la realidad psicosocial de los <span className='resaltar-txt'>empleados del Club Farallones y sus familias</span>, para contribuir al mejoramiento de sus condiciones de vida por medio de proyectos sociales a corto, mediano y largo plazo, que trascienden la satisfacción de necesidades económicas.</p>
                        <p>Si tiene alguna inquietud, por favor dirigirse a la oficina en la dirección relacionada en la parte de abajo o al correo electrónico <a href="mailto:trabajosocial@fundacionclubfarallones.org">trabajosocial@fundacionclubfarallones.org</a></p>
                    </div>
                    <form onSubmit={this.enviarDatos}>
                        <div className="form-group ">
                            <label htmlFor=""><strong>Dígite documento de identidad para continuar</strong></label>
                            <input type="text" name="docId" value={empleado.docId} onChange={this.cambioValor} id="docId"
                                className={((this.verificarError("error_docId")) ? "is-invalid" : "") + " form-control"} placeholder="" aria-describedby="helpId" />
                            <small id="helpId" className="invalid-feedback">Dígite su número de identificación sin espacios, puntos o comas.</small>
                        </div>

                        <div className='encuesta-terminos'>
                            <div className='aceptar-terminos'>
                                <input type="checkbox" name="terminos" value={terminos} onChange={this.aceptarTerminos} id="terminos" />
                                <div>Acepto terminos y condiciones</div>
                            </div>
                            <p className='ley-tratamiento-datos'>Declaro que autorizo a la Fundación Club Farallones para la recolección y tratamiento de mis datos personales y familiares, conforme a la <a href="http://fundacionclubfarallones.org/portal/politicadatos.html" target="_new">política de datos personales</a>. Entiendo que los datos serán usados para fines del objeto social de la Fundación, así mismo autorizo el uso de imágenes o videos míos para fines de socialización, promoción e informes de las actividades de la Fundación.</p>
                        </div>

                        <div className="server-error">{serverror}</div>

                        <hr width="90%" />
                        <div className="btn-group btn-acciones" aria-label="">
                            <button type="submit" 
                            className={ ((terminos===false) ? "disabled" : "")+" btn btn-success"} 
                            disabled={((terminos===false) ? "disabled" : "")}>Aceptar</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}
 
export default Intro;